import gql from 'graphql-tag';

export default gql`
  fragment hubspotCompanyPropertyDefinitionFragment on HubspotCompanyPropertyDefinition {
    id
    archivable
    calculated
    description
    externalOptions
    fieldType
    propertyType
    formField
    groupName
    hidden
    hubspotDefined
    label
    name
    options {
      label
      value
      hidden
      displayOrder
    }
    readOnlyDefinition
    readOnlyValue
    isDisplay
    labelText
    createdAt
    updatedAt
  }
`;
